export default "__VITE_ASSET__CyUAqwcS__"